"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
exports.Col = ({ className, children }) => {
    var haveColClassName = (className === null || className === void 0 ? void 0 : className.indexOf("col-")) > -1;
    var classes = classnames_1.default({ col: !haveColClassName }, className);
    return react_1.default.createElement("div", { className: classes }, children);
};
